module.exports = __webpack_public_path__ + "static/media/house.60edb198.png";